import { ListItemAvatar as MUIListItemAvatar } from '@mui/material';

import { styled } from '@liscio/ui';

export const ListItemAvatar = styled(MUIListItemAvatar)({
  paddingTop: '6px',
});

export default ListItemAvatar;
